<template>
    <div class="media-files-content card-box-style rounded">
        <div class="main-title border-style d-flex justify-content-between align-items-center">
            <h3>Activity Statistics</h3>

            <select class="form-select form-control" aria-label="Default select example">
                <option selected>7 days</option>
                <option value="1">15 days</option>
                <option value="2">10 days</option>
                <option value="3">5 days</option>
            </select>
        </div>

        <div class="table-height scroll-bar">
            <table class="table align-middle">
                <tbody>
                    <tr
                        v-for="statistic in statistics"
                        :key="statistic.id"
                    >
                        <td class="user-img">
                            <router-link to="/">
                                <img :src="require(`../../../assets/images/${statistic.image}`)" alt="student-1">
                            </router-link>
                            <h6>{{statistic.title}}</h6>
                        </td>

                        <td>
                            <span>{{statistic.videos}} Videos + {{statistic.lectures}} Lectures</span>
                        </td>

                        <td :class="statistic.class">
                            <span>{{statistic.editView}}</span>
                        </td>

                        <td>
                            <span>{{statistic.members}} Members</span>
                        </td>

                        <td class="members">
                            <span>{{statistic.mb}} MB</span>
                        </td>
                        
                        <td>
                            <button>
                                <img src="../../../assets/images/icon/download.svg" alt="download">
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import activityStatistics from './activityStatistics.json'

export default {
    name: 'ActivityStatistics',
    data (){
        return {
            statistics: activityStatistics,
        }
    }
}
</script>

<style lang="scss">
.media-files-content {
	padding-bottom: 0;
	margin-bottom: 20px;
	.table-height {
		height: 363px;
	}
	.table {
		border: none;
		margin-bottom: 0;
		&>tbody {
			border: none;
			height: 400px;
			overflow: auto;
		}
		&>:not(caption)>*>* {
			padding: 0;
			border: none;
			padding-bottom: 30px;
			&:last-child {
				margin-bottom: 0;
			}
		}
		tbody {
			tr {
				td {
					h6 {
						font-size: 14px;
						font-weight: 500;
						color: #292D32;
						display: inline-block;
						margin-left: 15px;
					}
					span {
						font-size: 12px;
						font-weight: 500;
						color: #67748E;
					}
					&.members {
						span {
							color: var(--heading-color);
						}
						&.blue-dot {
							span {
								position: relative;
								padding-left: 15px;
								&::before {
									content: "";
									position: absolute;
									top: 5px;
									left: 0;
									width: 8px;
									height: 8px;
									background-color: #1765FD;
									border-radius: 50px;
								}
							}
						}
						&.green-dot {
							span {
								position: relative;
								padding-left: 15px;
								&::before {
									content: "";
									position: absolute;
									top: 7px;
									left: 0;
									width: 8px;
									height: 8px;
									background-color: var(--main-color);
									border-radius: 50px;
								}
							}
						}
					}
					button {
						background-color: transparent;
					}
					&.user-img {
						width: 380px;
						display: block;
					}
				}
			}
		}
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .media-files-content {
        overflow: auto;
        table {
            tbody {
                tr {
                    td {
                        white-space: nowrap;
                        padding: 15px !important;
                    }
                }
            }
        }
    }
    .media-files-content {
        .scroll-bar {
            overflow: auto;
            &::-webkit-scrollbar {
                height: 5px;
            }
        }
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .media-files-content {
        overflow: auto;
        table {
            tbody {
                tr {
                    td {
                        white-space: nowrap;
                        padding: 15px !important;
                    }
                }
            }
        }
    }
    .media-files-content {
        .scroll-bar {
            overflow: auto;
            &::-webkit-scrollbar {
                height: 4px;
            }
        }
    }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .media-files-content {
        overflow: auto;
        table {
            tbody {
                tr {
                    td {
                        white-space: nowrap;
                        padding: 15px !important;
                    }
                }
            }
        }
    }
    .media-files-content {
        .scroll-bar {
            overflow: auto;
            &::-webkit-scrollbar {
                height: 4px;
            }
        }
    }
}

/* Min width 1200px to Max width 1320px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
    .media-files-content {
        overflow: auto;
        table {
            tbody {
                tr {
                    td {
                        white-space: nowrap;
                        padding: 15px !important;
                    }
                }
            }
        }
    }
    .media-files-content {
        .scroll-bar {
            overflow: auto;
            &::-webkit-scrollbar {
                height: 4px;
            }
        }
    }
}

/* Min width 1320px to Max width 1550px */
@media only screen and (min-width: 1320px) and (max-width: 1550px) {
    .media-files-content {
        overflow: auto;
        table {
            tbody {
                tr {
                    td {
                        white-space: nowrap;
                        padding: 15px !important;
                    }
                }
            }
        }
    }
    .media-files-content {
        .scroll-bar {
            overflow: auto;
            &::-webkit-scrollbar {
                height: 4px;
            }
        }
    }
}
</style>